const Vue = require('vue').default
const moment = require("moment")
const axios = require("axios")
//二次元配列の転置
const transpose = a => a[0].map((_, c) => a.map(r => r[c]));

let week=[]
moment.locale("ja");
const _past_update_hour = 2;
const today = (()=> {
  var ret
  if (parseInt(moment().format("H"), 10) >= _past_update_hour) {
    ret = moment().startOf('day')
  } else {
    ret = moment().startOf('day').subtract(1, 'days')
  }
  return moment.min([ret,moment("2024-07-01 05:01")])
})()
const lastMonday=today.clone().startOf('isoWeek')

for(var i=0;i<7;i++){
  var day=lastMonday.clone();
  day.add(i, 'd')
  if(day.isSameOrAfter(today)){
    day.add(-7, 'd')
  }
  week.push(day)
}

var pagePrediction = {
  data: function () {
    return {
      week:week
    }
  },
  mounted: function () {
    axios
      .get('/2021_chugoku/cms/past_calendar.json')
      .then((response) => {
        
        response.data.forEach((d) => {
          const date = moment(d.custom.preparing_date).startOf('day')
          this.week.forEach(w=>{
            if(w.isSame(date)){
              w.preparing=true
            }
          })
        })
        this.$forceUpdate()

      })
  },
  methods: {
  },

}

module.exports = pagePrediction